import React, { useState } from "react";
import { Alert, Form } from "antd";
import ProfileInput from "../components/ProfileInput";
import { Section, SectionTitle, SectionDescription, FormGroup, InputGroup, ButtonWrapper, AlertWrapper } from "../styles";
import { StyledButton } from "../../../components/styles";
import { updateAdminUserPassword } from "../../../redux/features/auth/authAsyncThunk";
import { useAppDispatch } from "../../../utils/hooks/redux";

const ChangePassword: React.FC = () => {
    const [form] = Form.useForm();
    const dispatch = useAppDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const handleSubmit = async () => {
        try {
            setIsLoading(true);
            const values = await form.validateFields().then((values) => {
                return values;
            }).catch((error: any) => {
                console.error("error:", error);
            });
            if (values) {
                await dispatch(updateAdminUserPassword(values)).unwrap();
                setIsSuccess(true);
                form.resetFields();
                setTimeout(() => {
                    setIsSuccess(false);
                }, 3000);
            }
        } catch (error: any) {
            setError(error || "Something went wrong, please try again later!");
            setTimeout(() => {
                setError(null);
            }, 5000);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Section>
            <SectionTitle>Change Password</SectionTitle>
            <SectionDescription>To update your password, enter your current password. If you don't remember it, use the 'Forgot Password' option on the login screen before proceeding.</SectionDescription>
            <Form form={form} layout="vertical" disabled={isLoading}>
                <FormGroup>
                    <InputGroup>
                        <ProfileInput name="currentPassword" label="Current Password" type="password" placeholder="Current Password" rules={[{ required: true, message: "Please enter your current password!" }]} />
                    </InputGroup>
                    <InputGroup>
                        <ProfileInput name="newPassword" label="New Password" type="password" placeholder="New Password" rules={[{ required: true, message: "Please enter your new password!" }]} />
                    </InputGroup>
                    <InputGroup>
                        <ProfileInput
                            name="confirmPassword"
                            label="Confirm New Password"
                            type="password"
                            placeholder="Confirm New Password"
                            rules={[
                                { required: true, message: "Please confirm your new password!" },
                                ({ getFieldValue }: { getFieldValue: (name: string) => string }) => ({
                                    validator(_: any, value: string) {
                                        if (!value || getFieldValue("newPassword") === value) {
                                            return Promise.resolve();
                                        }
                                        return Promise.reject(new Error("Confirm password doesn't match with New password."));
                                    },
                                }),
                            ]}
                        />
                    </InputGroup>
                </FormGroup>
                {isSuccess && (
                    <AlertWrapper>
                        <Alert message="Password updated successfully" showIcon type="success" />
                    </AlertWrapper>
                )}
                {error && (
                    <AlertWrapper>
                        <Alert message={error} showIcon type="error" />
                    </AlertWrapper>
                )}
                <ButtonWrapper>
                    <StyledButton type="primary" onClick={handleSubmit} loading={isLoading}>
                        Save Password
                    </StyledButton>
                </ButtonWrapper>
            </Form>
        </Section>
    );
};

export default ChangePassword;
